<!-- eslint-disable vue/require-v-for-key -->
<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <NuxtLayout>
    <div class="team-detail">
      <div class="t3-ce-frame frame-default">
        <media :query="{ minWidth: 992 }">
          <div class="team-detail-desktop">
            <LoadingIndicator
                :isLoading="loadingStatus"
                :translatedTexts="translatedTexts"
            />
            <template v-if="!loadingStatus && currentTeam">
              <TeamDetailHeadvisual :headvisual="currentTeam" />
              <div class="row team-detail-text">
                <div class="col-md-4 no-speaker-text">
                  <TeamDetailGetinTouchNoSpeaker :contact="currentTeam" />
                </div>
                <div class="col-md-8">
                  <div
                      v-if="currentTeam && currentTeam.Description"
                      v-html="currentTeam.Description"
                  ></div>
                  <div v-else>
                    <p>Keine Description vorhanden !!!</p>
                  </div>
                </div>
              </div>
              <div
                  v-if="currentTeam?.Projects?.length"
                  class="row team-user-project"
                  :data-aos="content_animation"
                  :data-aos-duration="content_animation_duration"
                  :data-aos-delay="content_animation_delay"
              >
                <h4>
                  {{ translatedText }}
                </h4>
              </div>
              <div v-if="currentTeam?.Projects?.length" class="row g-3 team-detail-relation">
                <div
                    v-for="(project, index) in (currentTeam?.Projects || [])"
                    :key="`${project.ID}-${index}`"
                    :class="
                    currentTeam?.Projects?.length == 2
                      ? 'col-md-6 image-480'
                      : 'col-md-4 image-400'
                  "
                >
                  {{ project.projects.video }}
                  <TeamDetailProjectsTeaser
                      :project="project"
                      :data-aos="content_animation"
                      :data-aos-duration="content_animation_duration"
                      :data-aos-delay="(index * content_animation_delay).toString()"
                      :apply-special-class="project.id === 62"
                  />
                </div>
              </div>
              <div v-if="currentTeam?.Contents?.length" class="team-detail-slider">
                <TeamDetailProjectsSlider
                    :items="currentTeam?.Contents || []"
                    :contact="currentTeam"
                    :data-aos="content_animation"
                    :data-aos-duration="content_animation_duration"
                    :data-aos-delay="content_animation_delay"
                />
              </div>
              <div
                  v-if="currentTeam?.SpeakerProfil === '1'"
                  class="team-detail-speaker-profil"
              >
                <h4>{{ currentTeam?.Firstname }} on Stage</h4>
                <TeamDetailSpeakerProfil
                    :contact="currentTeam"
                    :data-aos="content_animation"
                    :data-aos-duration="content_animation_duration"
                    :data-aos-delay="content_animation_delay"
                />
              </div>
              <a
                  class="back-to-list p-0"
                  :data-aos="content_animation"
                  :data-aos-duration="content_animation_duration"
                  :data-aos-delay="content_animation_delay"
                  :href="closeLink"
              >
                <font-awesome-icon :icon="['custom', 'big-arrow-left']" />
                <span>Zurück zur Teamliste</span>
              </a>
            </template>
          </div>
        </media>
        <media :query="{ maxWidth: 992 }">
          <template v-if="loadingStatus || currentTeam">
          <TeamDetailMobile
              :currentTeam="currentTeam"
              :loadingStatus="loadingStatus"
              :contact="currentTeam"
          />
          </template>
        </media>
      </div>
    </div>
  </NuxtLayout>
</template>

<script>
import { computed } from 'vue'
import Media from 'vue-media'
import LoadingIndicator from '~/components/Common/LoadingIndicator.vue'
import TeamDetailProjectsTeaser from '~/components/Team/Detail/TeamDetailProjectsTeaser'
import TeamDetailHeadvisual from '~/components/Team/Detail/TeamDetailHeadvisual'
import TeamDetailProjectsSlider from '~/components/Team/Detail/TeamDetailProjectsSlider'
import TeamDetailGetinTouchNoSpeaker from '~/components/Team/Detail/TeamDetailGetinTouchNoSpeaker'
import TeamDetailSpeakerProfil from '~/components/Team/Detail/TeamDetailSpeakerProfil'
import TeamDetailMobile from '~/components/Team/Detail/Mobile/TeamDetailMobile'
import { useTeamStore } from '~/composables/useTeamStore'
import { getPimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
import { buildLinkPreviewMeta, toAbsoluteUrl } from '~/composables/useLinkPreviewMeta'
import { buildStructuredDataScripts, normalizeStructuredDataEntries } from '~/composables/useStructuredData'
import { findEmployeeByRoute, getEmployeeRouteObject } from '~/composables/useDetailPageUrl'

export default {
  components: {
    LoadingIndicator,
    TeamDetailHeadvisual,
    TeamDetailProjectsTeaser,
    TeamDetailProjectsSlider,
    TeamDetailGetinTouchNoSpeaker,
    TeamDetailSpeakerProfil,
    TeamDetailMobile,
    Media
  },
  // Nuxt 3/4: metadata via definePageMeta in setup
  setup: async() => {
    if (typeof definePageMeta === 'function') {
      definePageMeta({ name: 'team-details-firstname' })
    }
    const store = useTeamStore()
    const nuxtApp = useNuxtApp()
    const route = useRoute()
    const localePath = useLocalePath()
    const { locale } = useI18n()
    const requestUrl = useRequestURL()

    const currentTeamSeo = computed(() => {
      const firstname = String(route.params.firstname || route.params.Firstname || '')
      if (!firstname) return null
      return findEmployeeByRoute(store.teams.value, firstname, locale.value)
    })

		const listingPath = computed(() => locale.value === 'en' ? '/en/team' : '/team')
		const listingCmsDataAsync = useAsyncData(
			() => `pimcore:team-listing-structured:${listingPath.value}`,
			async () => {
				try {
					return await $fetch('/api/pimcore/page', { method: 'GET', query: { path: listingPath.value } })
				} catch {
					return null
				}
			},
			{ server: true, watch: [listingPath] }
		)
		const listingCmsData = listingCmsDataAsync.data

		const structuredDataEntries = computed(() => [
			...normalizeStructuredDataEntries(listingCmsData.value?.structuredData?.merged),
			...normalizeStructuredDataEntries(currentTeamSeo.value?.StructuredData)
		])

    useHead(() => {
      const team = currentTeamSeo.value
      const title = typeof team?.Firstname === 'string' ? team.Firstname.trim() : ''
      const description = typeof team?.TeaserText === 'string' ? team.TeaserText.trim() : ''
      const imagePath = team?.PhotoUrl || team?.PhotoFullpath || team?.TeaserImage || ''
      const image = toAbsoluteUrl(getPimcoreAssetUrl(imagePath), requestUrl.origin)
      const url = toAbsoluteUrl(route.path, requestUrl.origin)

      return {
        title: title ? `${title} | Cromatics.de` : undefined,
			meta: [
				...(description
					? [{ key: 'description', name: 'description', content: description }]
					: []),
				...buildLinkPreviewMeta({
					title,
					description,
					url,
					image,
					imageAlt: team?.PhotoMetadata?.alt || title
				})
			],
			script: buildStructuredDataScripts(structuredDataEntries.value, 'team-structured-data')
      }
    })

		const teamsInitialAsync = await useAsyncData(
			() => `team-initial:${String(route.params.firstname || route.params.Firstname || '')}:${locale.value}`,
			() => $fetch('/api/pimcore/team', {
				params: {
					locale: locale.value,
					slug: String(route.params.firstname || route.params.Firstname || '')
				}
			})
		)

    const param = String(route.params.firstname || route.params.Firstname || '')
    if (teamsInitialAsync.error.value) {
      throw createError({ statusCode: 502, statusMessage: 'Failed to load team member data' })
    }
    // Prerendered/prefetched data skips the handler. Always apply the returned
    // detail payload, replacing the summary before selecting/rendering a profile.
    store.setTeams(teamsInitialAsync.data.value, locale.value, param)
    const matchedTeam = findEmployeeByRoute(store.teams.value, param, locale.value)

    if (param && !matchedTeam) {
      const redirect = await $fetch('/api/pimcore/page', { method: 'GET', query: { path: decodeURIComponent(route.path) } }).catch(() => null)
      if (redirect?.redirect && typeof redirect.redirectTo === 'string' && redirect.redirectTo.startsWith('/')) {
        await nuxtApp.runWithContext(() => navigateTo(redirect.redirectTo, {
          redirectCode: Number(redirect.statusCode) || 301,
          replace: true
        }))
      }
      throw createError({ statusCode: 404, statusMessage: 'Team member not found' })
    }

    if (matchedTeam) {
      const canonicalPath = localePath(getEmployeeRouteObject(matchedTeam, locale.value))
      if (typeof canonicalPath === 'string' && canonicalPath && route.path !== canonicalPath && route.fullPath !== canonicalPath) {
        await nuxtApp.runWithContext(() => navigateTo(canonicalPath, { redirectCode: 301, replace: true }))
      }
    }

    store.currentTeam.value = matchedTeam

    return { store, route, localePath }
  },
  data() {
    return {
      translatedText: '',
      isResolvingTeamRoute: false,
      translatedTexts: {
        Loading: ''
      }
    }
  },
  computed: {
    currentTeam() {
      const param = this.$route.params.firstname || this.$route.params.Firstname
      if (!param) return null

       const found = findEmployeeByRoute(this.store.teams.value, param, this.$i18n.locale)
       if (found) this.store.currentTeam.value = found
       return found || null
    },
    loadingStatus() {
      return this.store.loadingStatus.value
    },
    content_animation() {
      return this.store.content_animation.value
    },
    content_animation_duration() {
      return this.store.content_animation_duration.value
    },
    content_animation_delay() {
      return this.store.content_animation_delay.value
    },
    rowClasses() {
      return (textImage) =>
          textImage.alignment === 'right' ? 'row-reverse' : ''
    },
    uniqueCategories() {
      if (!this.currentTeam || !this.currentTeam.Projects) return []
      const allCategories = this.currentTeam.Projects.flatMap((project) =>
          project.categories.map((cat) => cat.key)
      )
      // Duplikate entfernen
      return [...new Set(allCategories)]
    },
    formattedCategories() {
      const categories = [...this.uniqueCategories]
      if (categories.length === 1) {
        return categories[0]
      } else {
        const lastCategory = categories.pop()
        return categories.join(', ') + ' & ' + lastCategory
      }
    },
    closeLink() {
      return this.$route.path.includes('/en/') ? '/en/team#c533' : '/team#c533'
    }
  },
  watch: {
    '$route.fullPath': {
      handler() {
        this.ensureTeamExists()
      }
    },
    loadingStatus: {
      handler() {
        this.ensureTeamExists()
      }
    },
    '$i18n.locale': {
      handler() {
        this.handleLocaleChange()
      }
    },
    '$route.params.firstname': {
      async handler(newVal) {
        const param = String(newVal || this.$route.params.Firstname || '')
        await this.resolveTeamRoute(param)
        this.ensureTeamExists()
        this.translateTexts()
      }
    },
    currentTeam(newVal) {
      if (newVal) this.translateTexts()
    }
  },
  mounted() {
    document.body.classList.add('project-detail-active')
    this.ensureTeamExists()
    if (this.currentTeam) this.translateTexts()
  },
  beforeUnmount() {
    document.body.classList.remove('project-detail-active')
  },
  methods: {
    ensureTeamExists() {
      const firstnameParam = this.$route.params.firstname || this.$route.params.Firstname

      if (!firstnameParam || this.loadingStatus || this.isResolvingTeamRoute) return
      if (this.currentTeam) return

      showError(createError({ statusCode: 404, statusMessage: 'Team member not found' }))
    },
    async resolveTeamRoute(param) {
      const routeParam = String(param || this.$route.params.firstname || this.$route.params.Firstname || '')
      if (!routeParam) return

      this.isResolvingTeamRoute = true
      try {
        await this.store.fetchTeams(this.$i18n.locale, routeParam)
        this.store.selectTeamByFirstname(routeParam)
      } finally {
        this.isResolvingTeamRoute = false
      }
    },
    async handleLocaleChange() {
      try {
        this.isResolvingTeamRoute = true
        const param = String(this.$route.params.firstname || this.$route.params.Firstname || '')
        await this.store.fetchTeams(this.$i18n.locale, param)
        this.store.selectTeamByFirstname(param)
        this.ensureTeamExists()
      } catch (e) {
        console.error('[TEAM][LOCALE CHANGE]', e)
      } finally {
        this.isResolvingTeamRoute = false
        this.translateTexts()
      }
    },
    translateTexts() {
      // Always set loading text, independent of currentTeam
      this.translatedTexts.Loading = this.$t('Loading')
      if (!this.currentTeam) return
      this.translatedText = this.$t('projectSentence', {
        category: this.formattedCategories,
        name: this.currentTeam.Firstname
      })
    }
  }
}
</script>
<style lang="scss">
.team-detail {
  display: flex;
  flex-direction: column;
  min-height: 75%;
  .team-detail-quotes {
    @include media-breakpoint-up(lg) {
      margin: 10.75rem 0;
    }
  }
  .team-detail-quotes .h1 {
    text-align: center;
    @include media-breakpoint-down(lg) {
      font-size: 60px;
      line-height: 48px;
    }
  }
  .team-detail-text {
    @include media-breakpoint-up(lg) {
      margin-bottom: 10.75rem;
    }
    .no-speaker-text p {
      display: none;
    }
  }
  .team-user-project {
    margin-bottom: 8rem;
  }
  .full-layout {
    @include media-breakpoint-up(lg) {
      img {
        height: 800px;
        width: 100%;
        object-fit: cover;
      }
    }
  }
  .image-480 {
    img {
      height: 600px;
    }
  }
  .image-400 {
    img {
      height: 400px;
    }
  }
  .special-img {
    @include media-breakpoint-up(md) {
      object-position: -230px;
    }
  }
  .frame-default {
    @include media-breakpoint-down(lg) {
      padding-left: 15px;
      padding-right: 15px;
      padding-bottom: 0 !important;
      margin-bottom: 0 !important;
    }
  }
  .loading-container {
    height: 680px;
    display: flex;
    align-items: center;
  }
  hr {
    display: none;
  }
}
.team-detail-desktop {
  .slide-text {
    text-transform: none !important;
  }
  .back-to-list {
    background: transparent;
    border: none;
    color: $green;
    display: flex;
    align-items: center;
    gap: 20px;
    svg {
      color: $green;
    }
  }
  .team-detail-speaker-profil {
    margin-bottom: 10rem;
  }
}
</style>
